
// Store zona login
// Verifico se la zona di login e' gia' stata usata altrimenti manda mail avviso nuova zona login
export function storeAndCheckLoginZone(jresponse) {
    let browser = get_browser();
    return $.ajax({
        type: 'POST',
        url: 'core/ajax/check_login_zone.php',
        data: {
            button: "check",
            location: jresponse.location,
            browser: browser
        }
    });
}

export function get_browser() {
    var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
    if(/trident/i.test(M[1])){
        tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
        return {name:'IE',version:(tem[1]||'')};
        }   
    if(M[1]==='Chrome'){
        tem=ua.match(/\bOPR|Edge\/(\d+)/)
        if(tem!=null)   {return {name:'Opera', version:tem[1]};}
        }   
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
    return {
      name: M[0],
      version: M[1]
    };
}


// Geolocalizza
export function geolocate() {
    return $.ajax({
        type: 'POST',
        url: 'core/getip_and_geolocate.php',
        data: {
            button: ""
        }
    })
} 
